import { render, staticRenderFns } from "./RowChildCount.vue?vue&type=template&id=0fdace3c&scoped=true"
import script from "./RowChildCount.vue?vue&type=script&lang=js"
export * from "./RowChildCount.vue?vue&type=script&lang=js"
import style0 from "./RowChildCount.vue?vue&type=style&index=0&id=0fdace3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdace3c",
  null
  
)

export default component.exports